import {IAddressResponseData, ICountriesLookup, PaymentFactory} from "@connox/typescript-library";
import React, {useEffect} from "react";
import {useTranslation} from "react-i18next";
import {useCheckoutContext} from "../../checkout/CheckoutContextProvider/CheckoutContextProvider";
import {emptyAddrDummy} from "../../checkout/steps/AddressStep/AddressStep";
import window from "../WindowExtended";
import {amazonPayAddressContainerId, cancelAmazonPay, widgetOptions} from "./AmazonPayLibrary";

interface IAmazonPayAddressWidget {
  availableCountries: ICountriesLookup[];
  onAddress: (amazonPayAddress: IAddressResponseData) => void;
  onError: (errorString: string) => void;
}

const AmazonPayAddressWidget: React.FC<IAmazonPayAddressWidget> = (props) => {
  const {checkout} = useCheckoutContext();
  const {t} = useTranslation("checkout");

  useEffect(() => {
    if (!window.amazon) {
      return;
    }

    new window.OffAmazonPayments.Widgets.AddressBook({
      amazonOrderReferenceId: window.orderReferenceId,
      onAddressSelect: async () => {
        window.isBillingAgreementAddressSet = true;
        const result = await PaymentFactory.getAmazonPayAddress(window.orderReferenceId);
        if (!props.availableCountries.find((country) => country.countryCode === result.countryCode)) {
          props.onError("Das ausgewählte Lieferland kann leider nicht beliefert werden");

          return;
        }
        window.amazon.Login.retrieveProfile(window.accessToken, (response) => {
          if (response.error) {
            props.onError(response.error);
          }
          const email = response.profile.PrimaryEmail;
          const ard = {
            ...emptyAddrDummy,
            city: result.city,
            countryCode: result.countryCode,
            email,
            state: result.state,
            zip: result.zip,
          };
          props.onAddress(ard);
        });
      },
      onError: (error) => {
        props.onError(error.getErrorCode());
      },
      ...widgetOptions,
    }).bind(amazonPayAddressContainerId);
  }, []);

  const cancel = () => {
    cancelAmazonPay();
    void checkout.put({paymentId: 0}).then(null);
  };

  return (
    <div style={{marginBottom: "1rem"}}>
      <div id={amazonPayAddressContainerId} style={{height: "230px", marginBottom: ".5rem"}}>
        {/* Filled by Amazon Pay */}
      </div>
      <span style={{cursor: "pointer", color: "#1ba1e2"}} onClick={cancel}>
        {t("Zahlung mit Amazon Pay abbrechen")}
      </span>
    </div>
  );
};

export default AmazonPayAddressWidget;
